import React, { Component } from 'react';

export class ODMPanelComponent extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                id="svg662"
                width="728"
                height="278"
                version="1.1"
                viewBox="0 0 728 278"
            >
                <style id="style2191">
                    .green-led-slow { } .header-background { } .yellow-led-fast { }{" "}
                    .green-led-fast { } .header { } .button { } .innerRing { } .outer { }
                </style>
                <defs id="defs666">
                    <clipPath id="clipPath686" clipPathUnits="userSpaceOnUse">
                        <path id="path684" d="M0 612h792V0H0z"></path>
                    </clipPath>
                    <clipPath id="clipPath730" clipPathUnits="userSpaceOnUse">
                        <path id="path728" d="M0 612h792V0H0z"></path>
                    </clipPath>
                    <clipPath id="clipPath916" clipPathUnits="userSpaceOnUse">
                        <path id="path914" d="M0 612h792V0H0z"></path>
                    </clipPath>
                    <clipPath id="clipPath972" clipPathUnits="userSpaceOnUse">
                        <path id="path970" d="M0 612h792V0H0z"></path>
                    </clipPath>
                    <clipPath id="clipPath1134" clipPathUnits="userSpaceOnUse">
                        <path id="path1132" d="M0 612h792V0H0z"></path>
                    </clipPath>
                    <clipPath id="clipPath1266" clipPathUnits="userSpaceOnUse">
                        <path id="path1264" d="M0 612h792V0H0z"></path>
                    </clipPath>
                    <clipPath id="clipPath1496" clipPathUnits="userSpaceOnUse">
                        <path id="path1494" d="M0 612h792V0H0z"></path>
                    </clipPath>
                    <clipPath id="clipPath1336" clipPathUnits="userSpaceOnUse">
                        <path id="path1334" d="M0 612h792V0H0z"></path>
                    </clipPath>
                    <clipPath id="clipPath1336-3" clipPathUnits="userSpaceOnUse">
                        <path id="path1334-7" d="M0 612h792V0H0z"></path>
                    </clipPath>
                </defs>
                <g id="g670" transform="matrix(1.33333 0 0 -1.33333 0 816)">
                    <g id="pcb" transform="translate(-.225)">
                        <path
                            id="path674"
                            fill="#318e4e"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M0 0h-184.943l-11.791 7.419h-123.209l-11-7.419h-214.772v208.166H0V24.851h-9.484V17.95H0z"
                            display="inline"
                            transform="translate(545.965 403.584)"
                        ></path>
                        <path
                            id="path678"
                            fill="none"
                            stroke="#30844c"
                            strokeDasharray="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="0.5"
                            d="M545.965 403.584H361.022l-11.791 7.419H226.022l-11-7.419H.25V611.75h545.715V428.435h-9.484v-6.901h9.484z"
                            display="inline"
                        ></path>
                        <g id="g680" display="inline" transform="translate(-96.353 86.986)">
                            <path
                                id="path690"
                                fill="#d4e5d8"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0a6.875 6.875 0 10-13.75 0A6.875 6.875 0 000 0"
                                display="inline"
                                transform="translate(622.375 514.5)"
                            ></path>
                            <path
                                id="path694"
                                fill="none"
                                stroke="#a3a4a3"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="1"
                                d="M622.375 514.5a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
                                display="inline"
                            ></path>
                            <path
                                id="path698"
                                fill="#d4e5d8"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0a6.875 6.875 0 10-13.75 0A6.875 6.875 0 000 0"
                                display="inline"
                                transform="translate(138.375 513.364)"
                            ></path>
                            <path
                                id="path702"
                                fill="none"
                                stroke="#a3a4a3"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="1"
                                d="M138.375 513.364a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
                                display="inline"
                            ></path>
                            <path
                                id="path706"
                                fill="#d4e5d8"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0a6.875 6.875 0 10-13.75 0A6.875 6.875 0 000 0"
                                display="inline"
                                transform="translate(138.375 326.65)"
                            ></path>
                            <path
                                id="path710"
                                fill="none"
                                stroke="#a3a4a3"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="1"
                                d="M138.375 326.65a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
                                display="inline"
                            ></path>
                            <path
                                id="path714"
                                fill="#d4e5d8"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0a6.875 6.875 0 10-13.75 0A6.875 6.875 0 000 0"
                                display="inline"
                                transform="translate(622.375 326.65)"
                            ></path>
                            <path
                                id="path718"
                                fill="none"
                                stroke="#a3a4a3"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="1"
                                d="M622.375 326.65a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
                                display="inline"
                            ></path>
                        </g>
                        <g
                            id="edgeConnector"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            display="inline"
                            transform="translate(-96.353 86.986)"
                        >
                            <path
                                id="path720"
                                fill="#856a3c"
                                d="M531.567 405.777h14.746v13.224h-14.746z"
                                transform="translate(96.353 -86.986)"
                            ></path>
                            <path
                                id="path722"
                                fill="#efd89d"
                                d="M531.567 415.335h14.468v2.59h-14.468z"
                                transform="translate(96.353 -86.986)"
                            ></path>
                            <path
                                id="path738"
                                fill="#efd89d"
                                d="M0 0h-11.879a1.295 1.295 0 000 2.589H0A1.294 1.294 0 000 0"
                                display="inline"
                                transform="translate(641.094 319.747)"
                            ></path>
                            <path
                                id="path734"
                                fill="#efd89d"
                                d="M0 0h-11.879a1.295 1.295 0 000 2.589H0A1.294 1.294 0 000 0"
                                display="inline"
                                transform="translate(641.094 324.06)"
                            ></path>
                        </g>
                        <g id="g6840">
                            <path
                                id="pwrLED"
                                fill="red"
                                strokeDasharray="none"
                                strokeWidth="0.474"
                                d="M424.837 -546.027H430.236V-542.057H424.837z"
                                transform="scale(1 -1)"
                            ></path>
                            <path
                                id="d2LED"
                                fill="#ffcd01"
                                fillOpacity="1"
                                strokeDasharray="none"
                                strokeWidth="0.474"
                                d="M344.97 -507.757H350.369V-503.787H344.97z"
                                transform="scale(1 -1)"
                            ></path>
                            <path
                                id="d1LED"
                                fill="#7fff2a"
                                strokeDasharray="none"
                                strokeWidth="0.474"
                                d="M326.162 -507.757H331.561V-503.787H326.162z"
                                className="green-led-slow"
                                transform="scale(1 -1)"
                            ></path>
                            <path
                                id="rect5091"
                                fill="#00f"
                                fillOpacity="1"
                                strokeDasharray="none"
                                strokeWidth="0.474"
                                d="M532.331 -505.216H537.73V-501.246H532.331z"
                                transform="scale(1 -1)"
                            ></path>
                        </g>
                        <path
                            id="lightSensor"
                            fill="#ccc"
                            fillOpacity="1"
                            strokeDasharray="none"
                            strokeWidth="0.75"
                            d="M246.779 -444.004H253.066V-434.57300000000004H246.779z"
                            transform="scale(1 -1)"
                        ></path>
                        <g id="piezo">
                            <circle
                                id="path6529"
                                cx="324.71"
                                cy="-436.844"
                                r="13.5"
                                fill="#333"
                                fillOpacity="1"
                                strokeDasharray="none"
                                strokeWidth="0.75"
                                transform="scale(1 -1)"
                            ></circle>
                        </g>
                        <g
                            id="g5882"
                            strokeWidth="0.75"
                            transform="translate(.225) scale(1 -1)"
                        >
                            <path
                                id="rect5710"
                                fill="#b3b3b3"
                                d="M409.655 -599.298H458.24199999999996V-551.981H409.655z"
                            ></path>
                            <path
                                id="rect5764"
                                fill="#000"
                                d="M416.006 -592.629H452.84299999999996V-558.015H416.006z"
                            ></path>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text5870"
                                x="421.599"
                                y="-578.656"
                                fill="#fff"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                <tspan
                                    id="tspan5868"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="421.599"
                                    y="-578.656"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    ODM-M
                                </tspan>
                            </text>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text5874"
                                x="420.135"
                                y="-568.812"
                                fill="#fff"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                <tspan
                                    id="tspan5872"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="420.135"
                                    y="-568.812"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    123456
                                </tspan>
                            </text>
                        </g>
                    </g>
                    <g id="buttons" display="inline" transform="translate(-96.353 86.986)">
                        <g id="escButton" className="button">
                            <path
                                id="path838"
                                fill="#2d2d2b"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M623.79 357.312h-19.48a5.208 5.208 0 00-5.209 5.208v19.481a5.208 5.208 0 005.208 5.208h19.48a5.208 5.208 0 005.208-5.208V362.52a5.208 5.208 0 00-5.208-5.208"
                                display="inline"
                            ></path>
                            <path
                                id="path842"
                                fill="none"
                                stroke="#000"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="1"
                                d="M623.79 357.312h-19.48a5.208 5.208 0 00-5.209 5.208v19.481a5.208 5.208 0 005.208 5.208h19.48a5.208 5.208 0 005.208-5.208V362.52a5.208 5.208 0 00-5.208-5.208z"
                                display="inline"
                            ></path>
                            <path
                                id="path846"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M624.725 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676"
                                className="innerRing"
                                display="inline"
                            ></path>
                            <path
                                id="path866"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M604.562 361.585a1.462 1.462 0 10-2.924 0 1.462 1.462 0 002.923 0"
                                display="inline"
                            ></path>
                            <path
                                id="path862"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M626.187 361.585a1.461 1.461 0 10-2.923-.001 1.461 1.461 0 002.923.001"
                                display="inline"
                            ></path>
                            <path
                                id="path858"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M626.187 382.342a1.461 1.461 0 10-2.923-.001 1.461 1.461 0 002.923.001"
                                display="inline"
                            ></path>
                            <path
                                id="path854"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M604.562 382.342a1.462 1.462 0 10-2.924 0 1.462 1.462 0 002.923 0"
                                display="inline"
                            ></path>
                            <path
                                id="path850"
                                fill="none"
                                stroke="#c9c4b1"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="1"
                                d="M624.725 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676z"
                                className="outer"
                                display="inline"
                            ></path>
                        </g>
                        <g id="enterButton" className="button">
                            <path
                                id="path2052"
                                fill="#2d2d2b"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M579.041 357.312h-19.48a5.208 5.208 0 00-5.208 5.208v19.481a5.208 5.208 0 005.208 5.208h19.48a5.208 5.208 0 005.208-5.208V362.52a5.208 5.208 0 00-5.208-5.208"
                                display="inline"
                            ></path>
                            <path
                                id="path2054"
                                fill="none"
                                stroke="#000"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="1"
                                d="M579.041 357.312h-19.48a5.208 5.208 0 00-5.208 5.208v19.481a5.208 5.208 0 005.208 5.208h19.48a5.208 5.208 0 005.208-5.208V362.52a5.208 5.208 0 00-5.208-5.208z"
                                display="inline"
                            ></path>
                            <path
                                id="path2056"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M579.977 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676"
                                className="innerRing"
                                display="inline"
                            ></path>
                            <path
                                id="path2058"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M559.814 361.585a1.462 1.462 0 10-2.924 0 1.462 1.462 0 002.924 0"
                                display="inline"
                            ></path>
                            <path
                                id="path2060"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M581.439 361.585a1.461 1.461 0 10-2.923-.001 1.461 1.461 0 002.923.001"
                                display="inline"
                            ></path>
                            <path
                                id="path2062"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M581.439 382.342a1.461 1.461 0 10-2.923-.001 1.461 1.461 0 002.923.001"
                                display="inline"
                            ></path>
                            <path
                                id="path2064"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M559.814 382.342a1.462 1.462 0 10-2.924 0 1.462 1.462 0 002.924 0"
                                display="inline"
                            ></path>
                            <path
                                id="path2066"
                                fill="none"
                                stroke="#c9c4b1"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="1"
                                d="M579.977 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676z"
                                className="outer"
                                display="inline"
                            ></path>
                        </g>
                        <g id="upRightButton" className="button">
                            <path
                                id="path774"
                                fill="#c2bfbc"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M535.842 357.312H516.36a5.208 5.208 0 00-5.207 5.208v19.481a5.208 5.208 0 005.207 5.208h19.48a5.208 5.208 0 005.209-5.208V362.52a5.208 5.208 0 00-5.208-5.208"
                                display="inline"
                            ></path>
                            <path
                                id="path778"
                                fill="none"
                                stroke="#000"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="1"
                                d="M535.842 357.312H516.36a5.208 5.208 0 00-5.207 5.208v19.481a5.208 5.208 0 005.207 5.208h19.48a5.208 5.208 0 005.209-5.208V362.52a5.208 5.208 0 00-5.208-5.208z"
                                display="inline"
                            ></path>
                            <path
                                id="path782"
                                fill="#f9f4dc"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M536.777 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676"
                                className="innerRing"
                                display="inline"
                            ></path>
                            <path
                                id="path786"
                                fill="none"
                                stroke="#c9c4b1"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="0.5"
                                d="M536.777 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676z"
                                className="outer"
                                display="none"
                            ></path>
                            <path
                                id="path790"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M516.613 382.342a1.461 1.461 0 10-2.922-.002 1.461 1.461 0 002.922.002"
                                display="inline"
                            ></path>
                            <path
                                id="path794"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M538.24 382.342a1.462 1.462 0 10-2.925 0 1.462 1.462 0 002.924 0"
                                display="inline"
                            ></path>
                            <path
                                id="path798"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M538.24 361.585a1.462 1.462 0 10-2.925 0 1.462 1.462 0 002.924 0"
                                display="inline"
                            ></path>
                            <path
                                id="path802"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M516.613 361.585a1.461 1.461 0 10-2.922-.002 1.461 1.461 0 002.922.002"
                                display="inline"
                            ></path>
                        </g>
                        <g id="bottomLeftButton" className="button">
                            <path
                                id="path2089"
                                fill="#c2bfbc"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M489.041 357.312h-19.48a5.208 5.208 0 00-5.208 5.208v19.481a5.208 5.208 0 005.207 5.208h19.481a5.208 5.208 0 005.208-5.208V362.52a5.208 5.208 0 00-5.208-5.208"
                                display="inline"
                            ></path>
                            <path
                                id="path2091"
                                fill="none"
                                stroke="#000"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="1"
                                d="M489.041 357.312h-19.48a5.208 5.208 0 00-5.208 5.208v19.481a5.208 5.208 0 005.207 5.208h19.481a5.208 5.208 0 005.208-5.208V362.52a5.208 5.208 0 00-5.208-5.208z"
                                display="inline"
                            ></path>
                            <path
                                id="path2095"
                                fill="#f9f4dc"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M489.977 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676"
                                className="innerRing"
                                display="inline"
                            ></path>
                            <path
                                id="path2093"
                                fill="none"
                                stroke="#c9c4b1"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="0.5"
                                d="M489.977 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676z"
                                className="outer"
                                display="inline"
                            ></path>
                            <path
                                id="path2097"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M469.813 382.342a1.461 1.461 0 10-2.922-.002 1.461 1.461 0 002.922.002"
                                display="inline"
                            ></path>
                            <path
                                id="path2099"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M491.439 382.342a1.462 1.462 0 10-2.924 0 1.462 1.462 0 002.924 0"
                                display="inline"
                            ></path>
                            <path
                                id="path2101"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M491.439 361.585a1.462 1.462 0 10-2.924 0 1.462 1.462 0 002.924 0"
                                display="inline"
                            ></path>
                            <path
                                id="path2103"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M469.813 361.585a1.461 1.461 0 10-2.922-.002 1.461 1.461 0 002.922.002"
                                display="inline"
                            ></path>
                        </g>
                    </g>
                    <g id="lcd" display="inline" transform="translate(-96.353 86.986)">
                        <path
                            id="path868"
                            fill="#38a05e"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="#30844c"
                            strokeDasharray="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="0.5"
                            d="M491.983 438.638h-163v83.073h163z"
                        ></path>
                        <path
                            id="path870"
                            fill="#141716"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="#30844c"
                            strokeDasharray="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="0.5"
                            d="M481.983 450.579h-143v59.348h143z"
                        ></path>
                        <path
                            id="path872"
                            fill="#d5dde2"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M475.983 462.934h-130.5v35.054h130.5z"
                        ></path>
                        <g id="g902" display="inline" transform="translate(490.254 516.785)">
                            <path
                                id="path876"
                                fill="#348e51"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0a3.421 3.421 0 10-6.843 0A3.421 3.421 0 000 0"
                                display="inline"
                                transform="translate(-152.74)"
                            ></path>
                            <path
                                id="path880"
                                fill="none"
                                stroke="#eed48d"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="0.5"
                                d="M-152.74 0a3.421 3.421 0 10-6.843 0 3.421 3.421 0 006.843 0z"
                                display="inline"
                            ></path>
                            <path
                                id="path884"
                                fill="#348e51"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0a3.42 3.42 0 10-6.841.001A3.42 3.42 0 000 0"
                                display="inline"
                                transform="translate(-152.74 -72.808)"
                            ></path>
                            <path
                                id="path888"
                                fill="none"
                                stroke="#eed48d"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="0.5"
                                d="M-152.74-72.808a3.42 3.42 0 10-6.841.001 3.42 3.42 0 006.84-.001z"
                                display="inline"
                            ></path>
                            <path
                                id="path892"
                                fill="#348e51"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0a3.42 3.42 0 10-6.841.001A3.42 3.42 0 000 0"
                                display="inline"
                                transform="translate(.844 -73.457)"
                            ></path>
                            <path
                                id="path896"
                                fill="none"
                                stroke="#eed48d"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="0.5"
                                d="M.844-73.457a3.42 3.42 0 10-6.841.002 3.42 3.42 0 006.84-.002z"
                                display="inline"
                            ></path>
                            <path
                                id="path900"
                                fill="#348e51"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0a3.42 3.42 0 10-6.842 0A3.42 3.42 0 000 0"
                                display="inline"
                            ></path>
                            <path
                                id="path904"
                                fill="none"
                                stroke="#eed48d"
                                strokeDasharray="none"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="0.5"
                                d="M0 0a3.42 3.42 0 10-6.842 0A3.42 3.42 0 000 0z"
                            ></path>
                        </g>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="line2Display"
                            x="410.051"
                            y="-396.322"
                            fill="#000"
                            fillOpacity="1"
                            strokeDasharray="none"
                            strokeWidth="0.637"
                            display="inline"
                            fontFamily="monospace"
                            fontSize="15.3"
                            fontStretch="normal"
                            fontStyle="normal"
                            fontVariant="normal"
                            fontWeight="normal"
                            textAnchor="middle"
                            transform="scale(.85 -1.17648)"
                        >
                            <tspan
                                id="tspan8135"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    WebkitTextAlign: "start",
                                    textAlign: "start",
                                }}
                                x="410.051"
                                y="-396.322"
                                fill="#000"
                                strokeWidth="0.637"
                                fontFamily="monospace"
                                fontSize="15.3"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                textAnchor="start"
                            >
                                AABBCCDDEEFFAABB
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "start",
                                textAlign: "start",
                            }}
                            id="line1Display"
                            x="410.051"
                            y="-409.279"
                            fill="#000"
                            fillOpacity="1"
                            strokeDasharray="none"
                            strokeWidth="0.637"
                            display="inline"
                            fontFamily="monospace"
                            fontSize="15.3"
                            fontStretch="normal"
                            fontStyle="normal"
                            fontVariant="normal"
                            fontWeight="normal"
                            textAnchor="start"
                            transform="scale(.85 -1.17648)"
                        >
                            <tspan
                                id="tspan8079"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    WebkitTextAlign: "start",
                                    textAlign: "start",
                                }}
                                x="410.051"
                                y="-409.279"
                                fill="#000"
                                strokeWidth="0.637"
                                fontFamily="monospace"
                                fontSize="15.3"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                textAnchor="start"
                            >
                                AABBCCDDEEFFAABB
                            </tspan>
                        </text>
                    </g>
                    <g id="headers">
                        <g id="nic" display="inline" transform="translate(-96.353 86.986)">
                            <path
                                id="path1140"
                                fill="#d6d4d3"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M306.772 479h-71.811v39.5h71.811z"
                            ></path>
                            <path
                                id="path1148"
                                fill="#5f6160"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0h19.516a3.438 3.438 0 100-6.875H0"
                                display="inline"
                                transform="translate(234.962 490.986)"
                            ></path>
                            <path
                                id="path1152"
                                fill="#c2bfbc"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0l18.457-.645c1.898 0 3.438-1.292 3.438-2.566v.259c0-1.274-1.54-2.307-3.438-2.307L0-6"
                                display="inline"
                                transform="translate(234.917 490.5)"
                            ></path>
                            <path
                                id="path1156"
                                fill="#5f6160"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0h19.517a3.437 3.437 0 000-6.875H0"
                                display="inline"
                                transform="translate(234.984 511.514)"
                            ></path>
                            <path
                                id="path1160"
                                fill="#c2bfbc"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0l18.457-.645c1.898 0 3.437-1.292 3.437-2.566v.259c0-1.274-1.539-2.307-3.437-2.307L0-6"
                                display="inline"
                                transform="translate(234.94 511.028)"
                            ></path>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text3715"
                                x="221.279"
                                y="-579.776"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="matrix(1 0 0 -1 96.353 -86.986)"
                                writingMode="vertical-lr"
                            >
                                <tspan id="tspan3717" x="221.279" y="-579.776">
                                    LINK
                                </tspan>
                            </text>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text3705"
                                x="221.359"
                                y="-606"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="matrix(1 0 0 -1 96.353 -86.986)"
                                writingMode="vertical-lr"
                            >
                                <tspan id="tspan3711" x="221.359" y="-606">
                                    ACT
                                </tspan>
                            </text>
                            <path
                                id="path1038"
                                fill="#ecb126"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M215.238 567.543h-4.728v8.662h4.728z"
                                transform="translate(96.353 -86.986)"
                            ></path>
                            <path
                                id="path1036"
                                fill="#74c043"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                strokeWidth="0.996"
                                d="M311.591 507.395h-4.728v8.633h4.728z"
                                className="green-led-fast"
                            ></path>
                            <path
                                id="path1082"
                                fill="#aeacad"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M214.03 576.804h-3.659V593.7h3.658z"
                                transform="translate(96.353 -86.986)"
                            ></path>
                        </g>
                        <g
                            id="addonHeader"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            clipPath="url(#clipPath1134)"
                            display="inline"
                            transform="translate(-96.353 86.986)"
                        >
                            <path
                                id="path1166"
                                fill="#2d2d2b"
                                d="M515.363 407.062h-16.896v37.09h16.896z"
                                display="inline"
                            ></path>
                            <g id="g1871" fill="#000" display="inline">
                                <path id="path1180" d="M505.135 416.1h-3.834v3.833h3.834z"></path>
                                <path id="path1182" d="M512.498 416.1h-3.833v3.833h3.833z"></path>
                                <path
                                    id="path1184"
                                    d="M505.135 409.258h-3.834v3.833h3.834z"
                                ></path>
                                <path
                                    id="path1186"
                                    d="M512.498 409.258h-3.833v3.833h3.833z"
                                ></path>
                                <path
                                    id="path1168"
                                    d="M505.135 437.318h-3.834v3.833h3.834z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path1170"
                                    d="M512.498 437.318h-3.833v3.833h3.833z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path1172"
                                    d="M505.135 430.252h-3.834v3.833h3.834z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path1174"
                                    d="M512.498 430.252h-3.833v3.833h3.833z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path1176"
                                    d="M505.135 422.941h-3.834v3.833h3.834z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path1178"
                                    d="M512.498 422.941h-3.833v3.833h3.833z"
                                    display="inline"
                                ></path>
                            </g>
                        </g>
                        <g id="g8645" transform="translate(-315.444 165.78)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8633"
                                x="345.35"
                                y="-349.635"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                            >
                                <tspan id="tspan1393">— +</tspan>
                                <tspan id="tspan1395">OUT</tspan>
                                <tspan id="tspan1397">12V</tspan>
                            </text>
                            <g id="powerOutput" className="header">
                                <path
                                    id="path8635"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path8637"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path8639"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path8641"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path8643"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                        </g>
                        <g id="g854" transform="translate(-315.444 201.798)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'sans-serif, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text836"
                                x="341.3"
                                y="-360.173"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="sans-serif"
                                fontSize="4"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan id="tspan2706" x="341.3" y="-360.173">
                                    D7
                                </tspan>
                            </text>
                            <path
                                id="relay1LED"
                                fill="#ffcd00"
                                fillOpacity="1"
                                strokeWidth="0.75"
                                d="M334.393 -363.587H339.792V-359.61699999999996H334.393z"
                                className="led yellow-led"
                                transform="scale(1 -1)"
                            ></path>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text3863"
                                x="345.073"
                                y="-357.581"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                            >
                                <tspan id="tspan1381">— +</tspan>
                                <tspan id="tspan1383"> POWER</tspan>
                                <tspan id="tspan1385"> LOCK</tspan>
                            </text>
                            <g id="relay1" className="header">
                                <path
                                    id="relay1Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path846-3"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path848"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path850-3"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path852"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                        </g>
                        <g id="g832" transform="translate(-315.329 131.697)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text814"
                                x="326.692"
                                y="-324.368"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="4"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan812"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="326.692"
                                    y="-324.368"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="4"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D5
                                </tspan>
                            </text>
                            <path
                                id="relay2LED"
                                fill="red"
                                strokeWidth="0.75"
                                d="M320.579 -328.179H325.978V-324.20899999999995H320.579z"
                                className="led red-led"
                                transform="scale(1 -1)"
                            ></path>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text820"
                                x="345.358"
                                y="-356.34"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                            >
                                <tspan
                                    id="tspan818"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="345.358"
                                    y="-356.34"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    writingMode="vertical-lr"
                                >
                                    RELAY2
                                </tspan>
                            </text>
                            <g id="relay2" className="header">
                                <path
                                    id="relay2Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path824"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path826"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path828"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path830"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                        </g>
                        <g id="g810" transform="translate(-315.329 95.181)">
                            <text
                                id="text792"
                                x="326.692"
                                y="-324.368"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontSize="4"
                                transform="scale(1 -1)"
                                xmlSpace="preserve"
                            >
                                <tspan
                                    id="tspan790"
                                    x="326.692"
                                    y="-324.368"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontSize="4"
                                >
                                    D
                                    <tspan
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        id="tspan1399"
                                        fontFamily="monospace"
                                        fontSize="4"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        6
                                    </tspan>
                                </tspan>
                            </text>
                            <path
                                id="relay3LED"
                                fill="red"
                                strokeWidth="0.75"
                                d="M320.579 -328.179H325.978V-324.20899999999995H320.579z"
                                className="led red-led"
                                transform="scale(1 -1)"
                            ></path>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text798"
                                x="345.438"
                                y="-356.265"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                            >
                                <tspan
                                    id="tspan796"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="345.438"
                                    y="-356.265"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    writingMode="vertical-lr"
                                >
                                    RELAY3
                                </tspan>
                            </text>
                            <g id="relay3" className="header">
                                <path
                                    id="relay3Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path802-1"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path804"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path806"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path808"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                        </g>
                        <g
                            id="g3749"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            clipPath="url(#clipPath1134)"
                            display="inline"
                            transform="translate(11.533 86.986)"
                        >
                            <path
                                id="path3725"
                                fill="#2d2d2b"
                                strokeWidth="0.77"
                                d="M515.363 407.062h-16.896v22.006h16.896z"
                                display="inline"
                            ></path>
                            <g id="g3747" fill="#000" display="inline">
                                <path id="path3727" d="M505.135 416.1h-3.834v3.833h3.834z"></path>
                                <path id="path3729" d="M512.498 416.1h-3.833v3.833h3.833z"></path>
                                <path
                                    id="path3731"
                                    d="M505.135 409.258h-3.834v3.833h3.834z"
                                ></path>
                                <path
                                    id="path3733"
                                    d="M512.498 409.258h-3.833v3.833h3.833z"
                                ></path>
                                <path
                                    id="path3743"
                                    d="M505.135 422.941h-3.834v3.833h3.834z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path3745"
                                    d="M512.498 422.941h-3.833v3.833h3.833z"
                                    display="inline"
                                ></path>
                            </g>
                        </g>
                        <g id="g3636" transform="rotate(-90 269.201 415.805)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text3592"
                                x="219.204"
                                y="-331"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan id="tspan3642" x="219.204" y="-331">
                                    HNCAP
                                </tspan>
                                <tspan id="tspan3644" x="219.204" y="-322.25">
                                    OPEN
                                </tspan>
                            </text>
                            <g
                                id="g3608"
                                className="header"
                                transform="matrix(1 0 0 -1 0 612.16)"
                            >
                                <path
                                    id="path3594"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M264.837 296.604h-37.07v18.952h37.07z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path3596"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(260.399 300.031)"
                                ></path>
                                <path
                                    id="path3598"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(257.294 305.81)"
                                ></path>
                                <path
                                    id="path3600"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(249.472 300.031)"
                                ></path>
                                <path
                                    id="path3602"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(246.366 305.81)"
                                ></path>
                                <path
                                    id="path3604"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.848v1.31h-3.62v13.125h9.661V1.31h-3.374V0z"
                                    className="port"
                                    display="inline"
                                    transform="translate(238.544 300.031)"
                                ></path>
                                <path
                                    id="path3606"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(235.439 305.81)"
                                ></path>
                            </g>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text3612"
                                x="-246.692"
                                y="320.752"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(-1 1)"
                                writingMode="vertical-lr"
                            >
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan3610"
                                    x="-246.692"
                                    y="320.752"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    writingMode="vertical-lr"
                                >
                                    COM
                                </tspan>
                            </text>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text3618"
                                x="253.227"
                                y="-331"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan id="tspan3638" x="253.227" y="-331">
                                    AUX
                                </tspan>
                                <tspan id="tspan3640" x="253.227" y="-322.25">
                                    INPUT
                                </tspan>
                            </text>
                            <g
                                id="g3626"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path3620"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M235.155 316.588v1.945"
                                ></path>
                                <path
                                    id="path3622"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M234.784 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path3624"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M244.909 316.588v1.945"
                                ></path>
                            </g>
                            <g
                                id="g3634"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path3628"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M247.341 316.588v1.945"
                                ></path>
                                <path
                                    id="path3630"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M246.97 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path3632"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M257.095 316.588v1.945"
                                ></path>
                            </g>
                        </g>
                        <g id="g950" transform="rotate(-90 235.015 449.869)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text908"
                                x="225.204"
                                y="-331"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan904"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="225.204"
                                    y="-331"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    REQ
                                </tspan>
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan906"
                                    x="225.204"
                                    y="-322.25"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    EXIT
                                </tspan>
                            </text>
                            <g
                                id="input12"
                                className="header"
                                transform="matrix(1 0 0 -1 0 612.16)"
                            >
                                <path
                                    id="input12Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M264.837 296.604h-37.07v18.952h37.07z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="input2"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(260.399 300.031)"
                                ></path>
                                <path
                                    id="path914-3"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(257.294 305.81)"
                                ></path>
                                <path
                                    id="path916"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(249.472 300.031)"
                                ></path>
                                <path
                                    id="path918"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(246.366 305.81)"
                                ></path>
                                <path
                                    id="input1"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.848v1.31h-3.62v13.125h9.661V1.31h-3.374V0z"
                                    className="port"
                                    display="inline"
                                    transform="translate(238.544 300.031)"
                                ></path>
                                <path
                                    id="path922"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(235.439 305.81)"
                                ></path>
                            </g>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text926"
                                x="-246.692"
                                y="320.752"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(-1 1)"
                                writingMode="vertical-lr"
                            >
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan924"
                                    x="-246.692"
                                    y="320.752"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    writingMode="vertical-lr"
                                >
                                    COM
                                </tspan>
                            </text>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text932"
                                x="253.227"
                                y="-331"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan id="tspan3584" x="253.227" y="-331">
                                    DOOR
                                </tspan>
                                <tspan id="tspan3586" x="253.227" y="-322.25">
                                    CNTAC
                                </tspan>
                            </text>
                            <g
                                id="g940"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path934"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M235.155 316.588v1.945"
                                ></path>
                                <path
                                    id="path936"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M234.784 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path938"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M244.909 316.588v1.945"
                                ></path>
                            </g>
                            <g
                                id="g948"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path942"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M247.341 316.588v1.945"
                                ></path>
                                <path
                                    id="path944"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M246.97 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path946"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M257.095 316.588v1.945"
                                ></path>
                            </g>
                        </g>
                        <g id="g3750" display="inline" transform="translate(-188.11 60.204)">
                            <g id="g4569">
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4281"
                                    x="346.381"
                                    y="-419.002"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontFamily="monospace"
                                    fontSize="4"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    transform="scale(1 -1)"
                                >
                                    <tspan
                                        id="tspan4279"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="346.381"
                                        y="-419.002"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="4"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D56
                                    </tspan>
                                </text>
                                <path
                                    id="reader2LED"
                                    fill="#ffcd00"
                                    fillOpacity="1"
                                    strokeWidth="0.75"
                                    d="M340.268 -422.812H345.667V-418.842H340.268z"
                                    className="led yellow-led"
                                    transform="scale(1 -1)"
                                ></path>
                            </g>
                            <g
                                id="g4564"
                                fontFamily="monospace"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4273"
                                    x="380"
                                    y="-492.55"
                                    fill="#fff"
                                    fillOpacity="1"
                                    stroke="#fff"
                                    strokeDasharray="none"
                                    strokeOpacity="1"
                                    strokeWidth="0"
                                    display="inline"
                                    fontSize="14"
                                    writingMode="vertical-lr"
                                >
                                    <tspan
                                        id="tspan4271"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="380"
                                        y="-492.55"
                                        fill="#fff"
                                        stroke="none"
                                        strokeDasharray="none"
                                        strokeWidth="0"
                                        fontFamily="monospace"
                                        fontSize="14"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                        opacity="1"
                                    >
                                        READER 2
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4060"
                                    x="358.133"
                                    y="-432.119"
                                    fill="red"
                                    strokeWidth="0.75"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan4058"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-432.119"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D0
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4046"
                                    x="358.133"
                                    y="-442.842"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan4044"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-442.842"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D1
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4052"
                                    x="358.133"
                                    y="-453.901"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan4050"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-453.901"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        BUZ
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4040"
                                    x="358.133"
                                    y="-464.567"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan4038"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-464.567"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        LED
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4034"
                                    x="358.133"
                                    y="-475.907"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan4032"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-475.907"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        PWR
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4028"
                                    x="358.349"
                                    y="-486.694"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan4026"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.349"
                                        y="-486.694"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        GND
                                    </tspan>
                                </text>
                            </g>
                            <g id="reader2">
                                <path
                                    id="reader2Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M357.063 426.452H338.11v69.844h18.952z"
                                    className="header-background"
                                    display="inline"
                                ></path>
                                <path
                                    id="path230"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 437.224h2.554v-6.287h-2.554v1.849h-1.31v-3.621h-13.125v9.66h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path234"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 434.118a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path222"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 448.15h2.554v-6.286h-2.554v1.849h-1.31v-3.621h-13.125v9.66h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path226"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 445.046a1.333 1.333 0 10-2.666-.001 1.333 1.333 0 002.666 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path214"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 459.078h2.554v-6.287h-2.554v1.849h-1.31v-3.621h-13.125v9.661h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path218"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 455.973a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path206"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 470.006h2.554v-6.287h-2.554v1.848h-1.31v-3.62h-13.125v9.66h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path210"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 466.9a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path198"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 480.933h2.554v-6.287h-2.554v1.849h-1.31v-3.621h-13.125v9.661h13.126v-3.374h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path202"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 477.828a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path190"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 491.86h2.554v-6.287h-2.554v1.85h-1.31V483.8h-13.125v9.661h13.126v-3.374h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path194"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 488.755a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                            </g>
                        </g>
                        <g
                            id="reader1Group"
                            display="inline"
                            transform="translate(-256.36 60.204)"
                        >
                            <g id="g489">
                                <text
                                    id="text485"
                                    x="346.381"
                                    y="-419.002"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="4"
                                    transform="scale(1 -1)"
                                    xmlSpace="preserve"
                                >
                                    <tspan
                                        id="tspan483"
                                        x="346.381"
                                        y="-419.002"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontSize="4"
                                    >
                                        D55
                                    </tspan>
                                </text>
                                <path
                                    id="reader1LED"
                                    fill="#ffcd00"
                                    fillOpacity="1"
                                    strokeWidth="0.75"
                                    d="M340.268 -422.812H345.667V-418.842H340.268z"
                                    className="led yellow-led"
                                    transform="scale(1 -1)"
                                ></path>
                            </g>
                            <g
                                id="g519"
                                display="inline"
                                fontFamily="monospace"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text493"
                                    x="380"
                                    y="-492.85"
                                    fill="#fff"
                                    fillOpacity="1"
                                    stroke="#fff"
                                    strokeDasharray="none"
                                    strokeOpacity="1"
                                    strokeWidth="0"
                                    display="inline"
                                    fontSize="14"
                                    writingMode="vertical-lr"
                                >
                                    <tspan
                                        id="tspan491"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="380"
                                        y="-492.85"
                                        fill="#fff"
                                        stroke="none"
                                        strokeDasharray="none"
                                        strokeWidth="0"
                                        fontFamily="monospace"
                                        fontSize="14"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                        opacity="1"
                                    >
                                        READER 1
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text497"
                                    x="358.133"
                                    y="-432.119"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan495"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-432.119"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D0
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text501"
                                    x="358.133"
                                    y="-442.842"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan499"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-442.842"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D1
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text505"
                                    x="358.133"
                                    y="-453.901"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan503"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-453.901"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        BUZ
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text509"
                                    x="358.133"
                                    y="-464.567"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan507"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-464.567"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        LED
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text513"
                                    x="358.133"
                                    y="-475.907"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan511"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-475.907"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        PWR
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text517"
                                    x="358.349"
                                    y="-486.694"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan515"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.349"
                                        y="-486.694"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        GND
                                    </tspan>
                                </text>
                            </g>
                            <g id="reader1" className="header">
                                <path
                                    id="reader1Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M357.063 426.452H338.11v69.844h18.952z"
                                    className="header-background"
                                    display="inline"
                                ></path>
                                <path
                                    id="path523"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 437.224h2.554v-6.287h-2.554v1.849h-1.31v-3.621h-13.125v9.66h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path525"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 434.118a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path527"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 448.15h2.554v-6.286h-2.554v1.849h-1.31v-3.621h-13.125v9.66h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path529"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 445.046a1.333 1.333 0 10-2.666-.001 1.333 1.333 0 002.666 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path531"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 459.078h2.554v-6.287h-2.554v1.849h-1.31v-3.621h-13.125v9.661h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path533"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 455.973a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path535"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 470.006h2.554v-6.287h-2.554v1.848h-1.31v-3.62h-13.125v9.66h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path537"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 466.9a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path539"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 480.933h2.554v-6.287h-2.554v1.849h-1.31v-3.621h-13.125v9.661h13.126v-3.374h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path541"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 477.828a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path543"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 491.86h2.554v-6.287h-2.554v1.85h-1.31V483.8h-13.125v9.661h13.126v-3.374h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path545"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 488.755a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                            </g>
                        </g>
                    </g>
                    <g
                        id="labels"
                        strokeDasharray="none"
                        strokeWidth="0.75"
                        fontFamily="monospace"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="normal"
                        textAnchor="middle"
                    >
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text6319"
                            x="422.716"
                            y="-535.653"
                            fill="#fff"
                            fillOpacity="1"
                            fontSize="7"
                            transform="scale(1 -1)"
                        >
                            <tspan
                                id="tspan6317"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                x="422.716"
                                y="-535.653"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                POE PWR
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text6329"
                            x="347.627"
                            y="-495.061"
                            fill="#fff"
                            fillOpacity="1"
                            fontSize="7"
                            transform="scale(1 -1)"
                        >
                            <tspan
                                id="tspan6327"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                x="347.627"
                                y="-495.061"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                D2
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text5477"
                            x="329.516"
                            y="-495.066"
                            fill="#7fff2a"
                            fontSize="7"
                            transform="scale(1 -1)"
                        >
                            <tspan
                                id="tspan5475"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                x="329.516"
                                y="-495.066"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                D1
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text6475"
                            x="261.862"
                            y="-435.549"
                            fill="#fff"
                            fillOpacity="1"
                            fontSize="7"
                            transform="scale(1 -1)"
                        >
                            <tspan
                                id="tspan6473"
                                x="261.862"
                                y="-435.549"
                                fill="#fff"
                                strokeWidth="0.75"
                            >
                                LS1
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text3909"
                            x="614.054"
                            y="-390.076"
                            fill="#fff"
                            display="inline"
                            fontSize="8"
                            transform="matrix(1 0 0 -1 -96.353 86.986)"
                        >
                            <tspan id="tspan3907" x="614.054" y="-390.076" strokeWidth="0.75">
                                SW4
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text3841"
                            x="516.803"
                            y="-432.21"
                            fill="#fff"
                            display="inline"
                            fontSize="10"
                            transform="scale(1 -1)"
                        >
                            <tspan id="tspan3839" x="516.803" y="-432.21" strokeWidth="0.75">
                                Esc
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text3903"
                            x="613.667"
                            y="-390.076"
                            fill="#fff"
                            display="inline"
                            fontSize="8"
                            transform="matrix(1 0 0 -1 -141.101 86.986)"
                        >
                            <tspan id="tspan3901" x="613.667" y="-390.076" strokeWidth="0.75">
                                SW3
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text3835"
                            x="614.004"
                            y="-345.224"
                            fill="#fff"
                            display="inline"
                            fontSize="10"
                            transform="matrix(1 0 0 -1 -141.101 86.986)"
                        >
                            <tspan
                                id="tspan3833"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                x="614.004"
                                y="-345.224"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                Enter
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text3851"
                            x="525.02"
                            y="-390.076"
                            fill="#fff"
                            display="inline"
                            fontSize="8"
                            transform="matrix(1 0 0 -1 -96.353 86.986)"
                        >
                            <tspan id="tspan3849" x="525.02" y="-390.076" strokeWidth="0.75">
                                SW2
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text3827"
                            x="525.245"
                            y="-343.912"
                            fill="#fff"
                            display="inline"
                            fontSize="16"
                            transform="matrix(1 0 0 -1 -96.353 86.986)"
                        >
                            <tspan id="tspan3831" x="530.061" y="-343.912">
                                ↑ →
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text3845"
                            x="526.237"
                            y="-390.076"
                            fill="#fff"
                            display="inline"
                            fontSize="8"
                            transform="matrix(1 0 0 -1 -143.154 86.986)"
                        >
                            <tspan
                                id="tspan3843"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                x="526.237"
                                y="-390.076"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                SW1
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text2170"
                            x="520.525"
                            y="-343.912"
                            fill="#fff"
                            display="inline"
                            fontSize="16"
                            transform="matrix(1 0 0 -1 -143.154 86.986)"
                        >
                            <tspan
                                id="tspan2168"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                x="525.341"
                                y="-343.912"
                                fill="#fff"
                                strokeDasharray="none"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="16"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                ← ↓
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text5535"
                            x="114.24"
                            y="-581.966"
                            fill="#ffcd01"
                            fillOpacity="1"
                            display="inline"
                            fontSize="7"
                            transform="scale(1 -1)"
                        >
                            <tspan
                                id="tspan5533"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                x="114.24"
                                y="-581.966"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                ETHERNET
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text6743"
                            x="346.668"
                            y="-433.565"
                            fill="gray"
                            fillOpacity="1"
                            fontSize="7"
                            transform="scale(1 -1)"
                        >
                            <tspan
                                id="tspan6741"
                                x="346.668"
                                y="-433.565"
                                fill="#fff"
                                strokeWidth="0.75"
                            >
                                BZ1
                            </tspan>
                        </text>
                    </g>
                    <g
                        id="seexModule"
                        display="inline"
                        transform="matrix(.78495 0 0 -.75 -20.177 610.5)"
                    >
                        <path
                            id="path1324"
                            fill="#38a05e"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M0 0h-133.687v39.859h118.061L0 26.859z"
                            display="inline"
                            transform="matrix(1.24965 0 0 -1.38663 701.493 158.772)"
                        ></path>
                        <path
                            id="path1328"
                            fill="none"
                            stroke="#30844c"
                            strokeDasharray="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="0.5"
                            d="M0 0h-133.687v39.859h118.061L0 26.859z"
                            display="inline"
                            transform="matrix(1.22293 0 0 -1.3271 699.707 157.586)"
                        ></path>
                        <g
                            id="g1338"
                            fill="#c6c5c1"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            display="inline"
                            transform="matrix(1.22293 0 0 -1.3271 545.829 113.05)"
                        >
                            <path
                                id="path1340"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                            ></path>
                            <path
                                id="path1344"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(0 -7.066)"
                            ></path>
                            <path
                                id="path1348"
                                d="M0 0a1.274 1.274 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(7.363 -7.066)"
                            ></path>
                            <path
                                id="path1352"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(0 -14.377)"
                            ></path>
                            <path
                                id="path1356"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(7.363 -14.377)"
                            ></path>
                            <path
                                id="path1360"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(0 -21.219)"
                            ></path>
                            <path
                                id="path1364"
                                d="M0 0a1.274 1.274 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(7.363 -21.219)"
                            ></path>
                            <path
                                id="path1368"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(0 -28.06)"
                            ></path>
                            <path
                                id="path1372"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(7.363 -28.06)"
                            ></path>
                            <path
                                id="path1376"
                                d="M0 0a1.274 1.274 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(7.363)"
                            ></path>
                        </g>
                        <g
                            id="g1378"
                            fill="#c6c5c1"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            display="inline"
                            transform="matrix(1.22293 0 0 -1.3271 684.841 130.993)"
                        >
                            <path
                                id="path1380"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                            ></path>
                            <path
                                id="path1384"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(0 -7.066)"
                            ></path>
                            <path
                                id="path1388"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(7.363 -7.066)"
                            ></path>
                            <path
                                id="path1392"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(0 -14.377)"
                            ></path>
                            <path
                                id="path1396"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(7.363 -14.377)"
                            ></path>
                            <path
                                id="path1400"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(7.363)"
                            ></path>
                        </g>
                        <g
                            id="g4878"
                            className="header"
                            transform="matrix(0 1.33333 -1.27397 0 981.891 -197.19)"
                        >
                            <path
                                id="path4864"
                                fill="#63b47f"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M264.837 296.604h-37.07v18.952h37.07z"
                                className="header-background"
                            ></path>
                            <path
                                id="path4866"
                                fill="#2c7039"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                transform="translate(260.399 300.031)"
                            ></path>
                            <path
                                id="path4868"
                                fill="#be9a3a"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                transform="translate(257.294 305.81)"
                            ></path>
                            <path
                                id="path4870"
                                fill="#2c7039"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                transform="translate(249.472 300.031)"
                            ></path>
                            <path
                                id="path4872"
                                fill="#be9a3a"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                transform="translate(246.366 305.81)"
                            ></path>
                            <path
                                id="path4874"
                                fill="#2c7039"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0v-2.554h-6.287V0h1.848v1.31h-3.62v13.125h9.661V1.31h-3.374V0z"
                                className="port"
                                display="inline"
                                transform="translate(238.544 300.031)"
                            ></path>
                            <path
                                id="path4876"
                                fill="#be9a3a"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                display="inline"
                                transform="translate(235.439 305.81)"
                            ></path>
                        </g>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text4890"
                            x="573.04"
                            y="117.228"
                            fill="red"
                            strokeWidth="0.977"
                            display="inline"
                            fontFamily="monospace"
                            fontSize="7.82"
                            fontStretch="normal"
                            fontStyle="normal"
                            fontVariant="normal"
                            fontWeight="normal"
                            transform="scale(.97749 1.02303)"
                        >
                            <tspan
                                id="tspan4888"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                x="573.04"
                                y="117.228"
                                fill="#fff"
                                strokeWidth="0.977"
                                fontFamily="monospace"
                                fontSize="7.82"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                GND
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text4896"
                            x="580.75"
                            y="131.507"
                            fill="red"
                            strokeWidth="0.977"
                            display="inline"
                            fontFamily="monospace"
                            fontSize="7.82"
                            fontStretch="normal"
                            fontStyle="normal"
                            fontVariant="normal"
                            fontWeight="normal"
                            transform="scale(.97749 1.02303)"
                        >
                            <tspan
                                id="tspan4894"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                x="580.75"
                                y="131.507"
                                fill="#fff"
                                strokeWidth="0.977"
                                fontFamily="monospace"
                                fontSize="7.82"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                D+
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text5002"
                            x="580.75"
                            y="144.855"
                            fill="red"
                            strokeWidth="0.977"
                            display="inline"
                            fontFamily="monospace"
                            fontSize="7.82"
                            fontStretch="normal"
                            fontStyle="normal"
                            fontVariant="normal"
                            fontWeight="normal"
                            transform="scale(.97749 1.02303)"
                        >
                            <tspan
                                id="tspan5000"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                x="580.75"
                                y="144.855"
                                fill="#fff"
                                strokeWidth="0.977"
                                fontFamily="monospace"
                                fontSize="7.82"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                D-
                            </tspan>
                        </text>
                        <path
                            id="rect5004"
                            fill="#7fff2a"
                            strokeDasharray="none"
                            strokeWidth="0.618"
                            d="M647.721 139.955H654.599V145.24800000000002H647.721z"
                            className="green-led-slow"
                        ></path>
                        <path
                            id="rect5080"
                            fill="#ffcd01"
                            fillOpacity="1"
                            strokeDasharray="none"
                            strokeWidth="0.618"
                            d="M647.721 122.595H654.599V127.888H647.721z"
                        ></path>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text5085"
                            x="661.044"
                            y="150.649"
                            fill="red"
                            strokeWidth="0.977"
                            display="inline"
                            fontFamily="monospace"
                            fontSize="7.82"
                            fontStretch="normal"
                            fontStyle="normal"
                            fontVariant="normal"
                            fontWeight="normal"
                            transform="scale(.97749 1.02303)"
                        >
                            <tspan
                                id="tspan5083"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                x="661.044"
                                y="150.649"
                                fill="#fff"
                                strokeWidth="0.977"
                                fontFamily="monospace"
                                fontSize="7.82"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                Rx
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text5089"
                            x="661.044"
                            y="115.883"
                            fill="red"
                            strokeWidth="0.977"
                            display="inline"
                            fontFamily="monospace"
                            fontSize="7.82"
                            fontStretch="normal"
                            fontStyle="normal"
                            fontVariant="normal"
                            fontWeight="normal"
                            transform="scale(.97749 1.02303)"
                        >
                            <tspan
                                id="tspan5087"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                x="661.044"
                                y="115.883"
                                fill="#fff"
                                strokeWidth="0.977"
                                fontFamily="monospace"
                                fontSize="7.82"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                Tx
                            </tspan>
                        </text>
                    </g>
                    <g id="apbModule" display="none" transform="translate(-96.353 86.986)">
                        <path
                            id="path1270"
                            fill="#38a05e"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M0 0v-21.384c0-5.363 4.348-9.71 9.711-9.71h38.13c5.363 0 9.711 4.347 9.711 9.71V-.753c0 5.363-4.348 9.711-9.711 9.711H9.711V0z"
                            display="inline"
                            transform="translate(484.914 435.675)"
                        ></path>
                        <path
                            id="path1274"
                            fill="none"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="#30844c"
                            strokeDasharray="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="0.5"
                            d="M484.914 435.675v-21.384c0-5.363 4.348-9.71 9.711-9.71h38.13c5.363 0 9.711 4.347 9.711 9.71v20.631c0 5.363-4.348 9.711-9.71 9.711h-38.13v-8.958z"
                            display="inline"
                        ></path>
                        <path
                            id="path1320"
                            fill="#2d2d2b"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M539.75 413.126h-13.648v13.648h13.648z"
                            display="inline"
                        ></path>
                        <path
                            id="path1318"
                            fill="none"
                            stroke="#fff"
                            strokeDasharray="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="0.25"
                            d="M514.672 410.084v32.515h-15.255v-35.536h12.455z"
                            display="inline"
                        ></path>
                        <g
                            id="g1304"
                            fill="#c6c5c1"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            display="inline"
                            transform="translate(504.509 410.828)"
                        >
                            <path
                                id="path1306"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                            ></path>
                            <path
                                id="path1310"
                                d="M0 0a1.274 1.274 0 10-2.549-.001A1.274 1.274 0 000 0"
                                display="inline"
                                transform="translate(7.363)"
                            ></path>
                            <path
                                id="path1314"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(7.363 28.06)"
                            ></path>
                            <path
                                id="path1302"
                                d="M0 0a1.274 1.274 0 10-2.549-.001A1.274 1.274 0 000 0"
                                display="inline"
                                transform="translate(7.363 6.841)"
                            ></path>
                            <path
                                id="path1298"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(0 6.841)"
                            ></path>
                            <path
                                id="path1294"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(7.363 13.683)"
                            ></path>
                            <path
                                id="path1290"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(0 13.683)"
                            ></path>
                            <path
                                id="path1286"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(7.363 20.995)"
                            ></path>
                            <path
                                id="path1282"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(0 20.995)"
                            ></path>
                            <path
                                id="path1278"
                                d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
                                display="inline"
                                transform="translate(0 28.06)"
                            ></path>
                        </g>
                    </g>
                    <g
                        id="g1490"
                        fillOpacity="1"
                        fillRule="nonzero"
                        stroke="none"
                        transform="translate(-96.88 88.813)"
                    >
                        <g id="greenLED" transform="translate(427.892 307.584)">
                            <path
                                id="path1530"
                                fill="#60bb48"
                                d="M0 0a3.167 3.167 0 00-6.334 0"
                            ></path>
                            <path
                                id="path1520"
                                fill="#60bb48"
                                d="M427.833 320.269H421.5v2.682h6.333z"
                                transform="translate(-427.892 -307.584)"
                            ></path>
                            <path
                                id="path1518"
                                fill="#2d2d2b"
                                d="M430.19 322.951h-10.932v13.145h10.932z"
                                transform="translate(-427.892 -307.584)"
                            ></path>
                        </g>
                        <g id="redLED" transform="translate(409.66 307.584)">
                            <path
                                id="path1526"
                                fill="#ee302d"
                                d="M0 0a3.167 3.167 0 00-6.334 0"
                            ></path>
                            <path
                                id="path1522"
                                fill="#ee302d"
                                d="M409.659 320.269h-6.334v2.682h6.334z"
                                transform="translate(-409.66 -307.584)"
                            ></path>
                            <path
                                id="path1516"
                                fill="#2d2d2b"
                                d="M411.958 322.951h-10.932v13.145h10.932z"
                                transform="translate(-409.66 -307.584)"
                            ></path>
                        </g>
                        <g
                            id="pirSensor"
                            fill="#b3b3b3"
                            display="inline"
                            transform="translate(372.173 336.096)"
                        >
                            <path id="path1508" d="M0 0h-21.864l1-16.475H-1z"></path>
                            <path
                                id="path1500"
                                d="M0 0c0-5.383-4.165-9.746-9.303-9.746-5.137 0-9.302 4.363-9.302 9.746"
                                transform="translate(-1.63 -24.35)"
                            ></path>
                        </g>
                        <g id="g1536" transform="translate(390.312 339.934)">
                            <path
                                id="path1538"
                                fill="#9f9e9c"
                                d="M0 0h-8.376a.931.931 0 00-.931.931v1.18c0 .514.417.931.931.931H0a.931.931 0 00.931-.931V.931A.931.931 0 000 0"
                            ></path>
                            <path
                                id="path1534"
                                fill="#9f9e9c"
                                d="M0 0h-8.376a.931.931 0 00-.931.931v1.18c0 .514.417.931.931.931H0a.931.931 0 00.931-.931V.931A.931.931 0 000 0"
                                transform="translate(-48.75)"
                            ></path>
                            <path
                                id="path1514"
                                fill="#2d2d2b"
                                d="M342.61 319.945h-10.474v16.151h10.474z"
                                transform="translate(-390.312 -339.934)"
                            ></path>
                            <path
                                id="path1512"
                                fill="#2d2d2b"
                                d="M391.36 319.945h-10.474v16.151h10.474z"
                                transform="translate(-390.312 -339.934)"
                            ></path>
                            <path
                                id="path1510"
                                fill="#2c7039"
                                d="M439.326 336.096H326v3.837h113.326z"
                                transform="translate(-390.312 -339.934)"
                            ></path>
                            <path
                                id="path1504"
                                fill="#2d2d2b"
                                d="M0 0h-9.747v-7h-108.85l-.11 7h-8.19v5.523H0z"
                                display="inline"
                                transform="translate(57.728 -25.187)"
                            ></path>
                        </g>
                    </g>
                </g>
            </svg>
        );
    }
}